export { default } from './LockedNavCong';
